import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { OpeningStation } from '../../../class/opening-station';
import { OpeningStationService } from '../../../service/opening-station/opening-station.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-opening-station',
  templateUrl: './new-opening-station.component.html',
  styleUrls: ['./new-opening-station.component.scss']
})
export class NewOpeningStationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: OpeningStation;
    @Input() new: OpeningStation;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public received_by: AbstractControl;
    public ericcson_id: AbstractControl;
    public expired_at: AbstractControl;
    public person_in: AbstractControl;
    public company: AbstractControl;
    public job: AbstractControl;
    public confirmation_open: AbstractControl;
    public confirmation_in: AbstractControl;
    public confirmation_close: AbstractControl;
    public closed_at: AbstractControl;
    public closed_by: AbstractControl;
    public station_status: AbstractControl;
    public user_id: AbstractControl;
    public station_id: AbstractControl;
    public created_at: AbstractControl;

    public optionsSelectionStatusEvent: any[];

    constructor(
        fb: FormBuilder,
        public openingStationService: OpeningStationService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.optionsSelectionStatusEvent = [];
        this.optionsSelectionStatusEvent.push({label: 'status close', value: '0'});
        this.optionsSelectionStatusEvent.push({label: 'status open', value: '1'});
        this.optionsSelectionStatusEvent.push({label: 'status pending close', value: '2'});

        this.form = fb.group({
            'received_by': ['', Validators.compose([Validators.minLength(2)])],
            'ericcson_id': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'expired_at': ['', Validators.compose([Validators.minLength(2)])],
            'person_in': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'company': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'job': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'confirmation_open': ['', Validators.compose([Validators.minLength(2)])],
            'confirmation_in': ['', Validators.compose([Validators.minLength(2)])],
            'confirmation_close': [''],
            'closed_at': [''],
            'closed_by': [''],
            'station_status': [''],
            'user_id': [{value: '', disabled: true}],
            'station_id': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'created_at': [{value: '', disabled: true}],
        });

        this.received_by = this.form.controls['received_by'];
        this.ericcson_id = this.form.controls['ericcson_id'];
        this.expired_at = this.form.controls['expired_at'];
        this.person_in = this.form.controls['person_in'];
        this.company = this.form.controls['company'];
        this.job = this.form.controls['job'];
        this.confirmation_open = this.form.controls['confirmation_open'];
        this.confirmation_in = this.form.controls['confirmation_in'];
        this.confirmation_close = this.form.controls['confirmation_close'];
        this.closed_at = this.form.controls['closed_at'];
        this.closed_by = this.form.controls['closed_by'];
        this.station_status = this.form.controls['station_status'];
        this.user_id = this.form.controls['user_id'];
        this.station_id = this.form.controls['station_id'];
        this.created_at = this.form.controls['created_at'];
    }

    ngOnInit() {
        if (this.edit) {
            this.received_by.setValue(this.edit.received_by);
            this.ericcson_id.setValue(this.edit.ericcson_id);
            this.expired_at.setValue(this.edit.expired_at);
            this.person_in.setValue(this.edit.person_in);
            this.company.setValue(this.edit.company);
            this.job.setValue(this.edit.job);
            this.confirmation_open.setValue(this.edit.confirmation_open);
            this.confirmation_in.setValue(this.edit.confirmation_in);
            this.confirmation_close.setValue(this.edit.confirmation_close);
            this.closed_at.setValue(this.edit.closed_at);
            this.closed_by.setValue(this.edit.closed_by);
            this.station_status.setValue(this.edit.station_status);
            this.user_id.setValue(this.edit.user.employee.name);
            this.station_id.setValue(this.edit.station);
            this.created_at.setValue(this.edit.created_at);
        } else if (this.new) {
            this.received_by.setValue(this.new.received_by);
            this.ericcson_id.setValue(this.new.ericcson_id);
            this.expired_at.setValue(this.new.expired_at);
            this.person_in.setValue(this.new.person_in);
            this.company.setValue(this.new.company);
            this.job.setValue(this.new.job);
            this.confirmation_open.setValue(this.new.confirmation_open);
            this.confirmation_in.setValue(this.new.confirmation_in);
            this.confirmation_close.setValue(this.new.confirmation_close);
            this.closed_at.setValue(this.new.closed_at);
            this.closed_by.setValue(this.new.closed_by);
            this.station_status.setValue(this.new.station_status);
            if (this.new.user) {
                this.user_id.setValue(this.new.user.employee.name);
            }
            this.station_id.setValue(this.new.station_id);
            this.created_at.setValue(this.new.created_at);
        } else {
            this.station_status.setValue(false);
        }
    }

    public cancelOpeningStation () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public newOpeningStation(values: OpeningStation) {
        const param = {
            'received_by': values.received_by,
            'ericcson_id': values.ericcson_id,
            'expired_at': values.expired_at,
            'person_in': values.person_in,
            'company': values.company,
            'job': values.job,
            'confirmation_open': values.confirmation_open,
            'confirmation_in': values.confirmation_in,
            'confirmation_close': values.confirmation_close,
            'closed_at': values.closed_at,
            'closed_by': values.closed_by,
            'station_status': values.station_status,
            'station_id': values.station_id.id,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.openingStationService.updateOpeningStation(this.edit.id, param)
                :
                this.openingStationService.newOpeningStation(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public checkOtherValidation (values) {
        let check = false;
        if (values) {
            if (values.station_id) {
                if (values.station_id.id) {
                    check = true;
                } else {
                    return false;
                }
            }
        }
        return check;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/opening-stations/new-opening-station/new-opening-station.component.ts